import { Routes } from '@angular/router';

import { SUPER_ADMIN_ROUTE } from '@shared/enum/common.enum';
import { superAdminGuard, superAdminLoginGuard } from '@shared/guard/super-admin.guard';

/**
 * Super Admin console. Separate session (sessionStorage) and guards; tenant auth guards and
 * RouteModuleMapping permissions do not apply here.
 */
export const superAdminRoutes: Routes = [
    {
        path: SUPER_ADMIN_ROUTE.LOGIN,
        canActivate: [superAdminLoginGuard],
        loadComponent: () =>
            import('@components/super-admin/login/super-admin-login.component').then(
                (m) => m.SuperAdminLoginComponent
            ),
    },
    {
        path: SUPER_ADMIN_ROUTE.ROOT,
        canActivate: [superAdminGuard],
        loadComponent: () =>
            import('@components/super-admin/layout/super-admin-layout.component').then(
                (m) => m.SuperAdminLayoutComponent
            ),
        children: [
            {
                path: '',
                loadComponent: () =>
                    import('@components/super-admin/credit-management/super-admin-credit-management.component').then(
                        (m) => m.SuperAdminCreditManagementComponent
                    ),
            },
        ],
    },
];
